import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { catchError, map, Observable, take } from 'rxjs';
import { SearchLiteraturesRequest, Literature } from './search-literatures.model';
import { failStatus, successStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class SearchLiteraturesAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
  ) {}

  fetch(query: string, pageNumber: number): Observable<SearchLiteraturesRequest> {
    const params: { [key: string]: string } = {};

    if (pageNumber) {
      params['currentPage'] = pageNumber.toString();
    }

    params['query'] = query;

    const url = this.occEndPointService.buildUrl('literatureSearch', { queryParams: params });
    return this.http.get(url).pipe(
      take(1),
      map((data: any) => ({
        ...this.normalize(data),
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

  normalize(data: any): SearchLiteraturesRequest {
    const result: SearchLiteraturesRequest = {
      literatures: (data.literatures || []).map((item: any) => this.mapToLiterature(item)),
      pagination: data?.pagination,
    };

    return result;
  }

  protected mapToLiterature(item: any): Literature {
    return {
      uniqueID: item.uniqueID || item.id || '',
      publicationNumber: item.publicationNumber || '',
      itemStatus: item.itemStatus || '',
      title: item.title || '',
      brand: item.brand || '',
      category: item.category || '',
      resourceType: item.resourceType || '',
      industry: item.industry || '',
      language: item.language || '',
      keywords: item.keywords || '',
      metaDescription: item.metaDescription || '',
      documentType: item.documentType || '',
      documentLink: item.documentLink || '',
      documentSize: item.documentSize || 0,
      thumbnail: item.thumbnail || '',
      url: item.label || item.url || '/',
    };
  }
}
